import { render, staticRenderFns } from "./AvatarCell.vue?vue&type=template&id=015982b9&"
import script from "./AvatarCell.vue?vue&type=script&lang=js&"
export * from "./AvatarCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports